import React from "react";
import { motion } from "framer-motion";
import { FileCheck2 } from "lucide-react";
import { PublicLayout } from "../components/Layout";
import { SecurePdfViewer } from "../components/SecurePdfViewer";

const CERTIFICATES = [
  { id: "gst", title: "GST Certificate", number: "29ACPPC5869C1ZB", file: "/certificates/gst-certificate.pdf", accent: "#12355B" },
  { id: "iec", title: "IEC Certificate", number: "ACPPC5869C", file: "/certificates/iec-certificate.pdf", accent: "#2F9E44" },
  { id: "msme", title: "MSME Udyam Registration", number: "UDYAM-KR-03-0251450", file: "/certificates/msme-certificate.pdf", accent: "#B8823E" },
  { id: "tan", title: "TAN Certificate", number: "BLRM36977D", file: "/certificates/tan-certificate.pdf", accent: "#5B6675" },
];

const Certifications = () => (
  <PublicLayout>
    <section className="pt-28 md:pt-32 pb-16 md:pb-20 bg-[#F7F8F5] relative">
      <div className="grid-texture absolute inset-0 opacity-60" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 relative">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#2F9E44] mb-4">Certifications</div>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight text-[#222629] max-w-3xl leading-[1.05]">
          A certified trader in every discipline.
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-[#5B6675] max-w-2xl leading-relaxed">
          R K STEEL is registered and compliant across all statutory bodies. Preview our official certifications below — presented in view-only mode.
        </p>
      </div>
    </section>

    <section className="py-12 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-10 grid md:grid-cols-2 gap-6 md:gap-8">
        {CERTIFICATES.map((c, i) => (
          <motion.div
            key={c.id}
            data-testid={`cert-card-${c.id}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group lift-card bg-white border border-neutral-200 rounded-2xl overflow-hidden relative"
          >
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
              style={{ boxShadow: `0 0 60px -10px ${c.accent}55 inset` }}
            />
            <div className="p-6 md:p-7 flex items-start gap-4 relative">
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-white shrink-0" style={{ background: c.accent }}>
                <FileCheck2 size={20} />
              </div>
              <div className="min-w-0">
                <div className="text-[10px] tracking-[0.28em] uppercase" style={{ color: c.accent }}>Certificate</div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-[#222629] mt-1 leading-tight tracking-tight">{c.title}</h3>
                <div className="font-mono text-xs text-neutral-500 mt-1 wrap-anywhere">No: {c.number}</div>
              </div>
            </div>
            <div className="px-6 md:px-7 pb-6 md:pb-7 relative">
              <SecurePdfViewer file={c.file} testIdPrefix={`cert-${c.id}`} accent={c.accent} />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  </PublicLayout>
);

export default Certifications;
